module.exports = {"data":{"site":{"siteMetadata":{"title":"alexk.io"}},"allMarkdownRemark":{"group":[{"fieldValue":"flights","totalCount":1},{"fieldValue":"travel","totalCount":1}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags.json
// module id = 419
// module chunks = 55702396619907